import { render, staticRenderFns } from "./organizationProject.vue?vue&type=template&id=625c3f27&scoped=true&"
import script from "./organizationProject.vue?vue&type=script&lang=js&"
export * from "./organizationProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c3f27",
  null
  
)

export default component.exports